import React from 'react';
import {
    Show,
    TextField,
    SimpleShowLayout
} from 'react-admin';

const ProfesionalesShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="nombres" />
        <TextField source="apellidos" />
        <TextField source="matricula" />
    </SimpleShowLayout>
  </Show>
);

export default ProfesionalesShow;
